



















































































































































































































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import NumericStepper from '@/components/shared/NumericStepper.vue'
import {
  allBoxesInSequence,
  createSequence,
  findSequenceByBoxId,
  calculatePlacePosition,
  getSequenceGripperBorder,
  calculatePickPosition,
  calculatePickPosition2,
  getCustomInfeedRotation,
  getCustomSolutionConveyorLabelPosition,
  hasCustomInfeedRotation
} from '@/libs/pattern/sequenceUtils'
import { Sequence, BoxPosition } from '@/model'
import { getBoxDef, BoxDef } from '@/libs/pattern/boxDef'
import { getBorderPoints } from '@/libs/pattern/borderUtils'
import { getAlignedGroupsInline } from '@/libs/pattern/layerSort'
import { compare } from '@/libs/pattern/utils'

interface CustomInfeedPreviewLabel {
  id: number
  x: number
  y: number
  width: number
  height: number
}

@Component ({
  components: {NumericStepper}
})
export default class SequencePanel extends Vue {
  @Prop () gripperLength!: number
  @Prop () gripperWidth!: number
  @Prop ({ default: 1 }) vacuumSections!: number
  @Prop ({ default: false }) vacuumSectionSelectionEnabled!: boolean
  @Prop () boxes!: any
  @Prop () sequences!: any
  @Prop () currentPickSelection!: number[]
  @Prop () selectedBox!: number
  @Prop () box!: any
  @Prop () programSettings!: any
  @Prop () palletRotation!: any
  @Prop () sequenceBoxSelection!: boolean
  @Prop ({ default: 1 }) currentSequenceId!: number

  private valid: boolean = false
  private sequenceId: number = 1
  private showGripperOverlay: boolean = false
  private customInfeedRotationEnabled: boolean = false
  private customInfeedRotation: number = 90
  private xGripperOffset: number = 0
  private yGripperOffset: number = 0
  private approachAngle: number = 45
  private approachDistance: number = 200
  private pickId: number = 1
  private pickZRotation: number | undefined = 0
  private placeZRotation: number = 0
  private selectedVacuumSections: number[] = [1]
  private rotations: number[] = [0, 90, 180, 270]
  private customInfeedRotations: number[] = [90, 180, 270]
  private pickZRotations: number[] = []
  private placeZRotations: number[] = []
  private boxSelectionOngoing: boolean = false
  private placeZRotationDisabled: boolean = false
  private pickZRotationDisabled: boolean = false
  private rules: object = {
    validOffsetX: (v: any) => this.isValidOffsetX (v),
    validOffsetY: (v: any) => this.isValidOffsetY (v),
    validApproachAngle: (v: any) => this.isValidApproachAngle (v),
    validApproachDistance: (v: any) => this.isValidApproachDistance (v)
  }
  private copySequences: Sequence[] = []
  private currentSequence: Sequence | undefined
  private boxDef!: BoxDef
  private maxSequenceId: number = Infinity
  private maxPickId: number = 2
  private preserveSequenceSelectionOnDone: boolean = false
  private preserveSequenceSelectionOnSequenceUpdate: boolean = false
  // =================
  // LIFECYCLE HOOKS
  // =================
  created () {
    this.boxDef = getBoxDef(this.box, this.programSettings)
    this.sequenceId = this.currentSequenceId || 1
    this.copySequences = JSON.parse (JSON.stringify (this.sequences))
    if (this.copySequences.length > 0) {
      this.currentSequence = this.copySequences.find(s => s.id === this.sequenceId) || this.copySequences[0]
      this.sequenceId = Number(this.currentSequence.id!)
      // if (this.copySequences.flatMap(s => s.place).some(p => p!.x == null || p!.y == null)) {
      //   console.log('update place positions...  ')
      this.updatePlacePositions ()
      // }
      // if (this.copySequences.flatMap(s => s.pick).some(p => p!.x == null || p!.y == null)) {
      //   console.log('update pick positions...  ')
      this.updatePickPositions ()
      // }
    }
  }

  mounted () {
    this.validateFields ()
    this.updateDisplayValues (this.currentSequence!)
  }

  // =================
  // WATCHERS
  // =================
  @Watch ('sequences', {deep: true})
  private sequencesWatcher () {
    this.copySequences = JSON.parse(JSON.stringify(this.sequences))
    this.currentSequence = this.copySequences.find(s => s.id === this.sequenceId)!

    // check if current pick selection matches with sequence
    const currentPick = (this.currentSequence != null && this.currentSequence.pick![this.pickId - 1] != null)
        ? this.currentSequence.pick![this.pickId - 1].boxesGroup
        : null

    // reset ids
    if (!this.currentSequence) {
      this.sequenceId = 1
      this.pickId = 1
    } else if (this.preserveSequenceSelectionOnDone || this.preserveSequenceSelectionOnSequenceUpdate) {
      // Keep the selector on the sequence that was just completed or edited while updates propagate.
    } else if (!compare(currentPick, this.currentPickSelection)) {
      this.selectSequenceByPickSelection()
    }
    this.updateDisplayValues (this.currentSequence)
    this.validateFields()
    window.setTimeout(() => {
      this.preserveSequenceSelectionOnSequenceUpdate = false
    }, 0)
  }

  @Watch('boxes', {deep: true})
  private boxesWatcher() {
    this.validateFields()
  }

  @Watch('currentSequenceId')
  private currentSequenceIdWatcher() {
    if (this.currentSequenceId === this.sequenceId) {
      return
    }
    const sequence = this.copySequences.find(s => s.id === this.currentSequenceId)
    if (!sequence) {
      return
    }
    this.sequenceId = Number(this.currentSequenceId)
    this.currentSequence = sequence
    this.updateDisplayValues(this.currentSequence)
    this.validateFields()
    const pick = this.currentSequence.pick && this.currentSequence.pick[this.pickId - 1]
    this.$emit('pickSelection', pick ? pick.boxesGroup : [])
    this.handleGripperOverlay()
  }

  @Watch ('selectedBox')
  private selectedBoxWatcher () {
    if (this.selectedBox < 0) {
      const currentPick = (this.currentSequence && this.currentSequence.pick && this.currentSequence.pick[this.pickId - 1])
          ? this.currentSequence.pick[this.pickId - 1].boxesGroup
          : []
      if (this.boxSelectionOngoing || this.preserveSequenceSelectionOnDone || compare(currentPick, this.currentPickSelection)) {
        return
      }
      this.$emit('pickSelection', [])
      return
    }
    this.preserveSequenceSelectionOnDone = false

    // if box is already part of a sequence, update current sequence
    const selSequence = findSequenceByBoxId(this.selectedBox, this.copySequences)
    if (selSequence) {
      if (this.boxSelectionOngoing) {
        return
      }

      this.currentSequence = selSequence
      this.sequenceId = Number(selSequence.id!)
      this.pickId = selSequence.pick![0].boxesGroup!.includes(this.selectedBox) ? 1 : 2
      this.updateDisplayValues(this.currentSequence)
      this.$emit('sequenceSelection', this.sequenceId)
      const pickSelection = [...selSequence.pick![this.pickId - 1].boxesGroup!]
      this.$emit('pickSelection', pickSelection)
      return
    }
    if (!this.boxSelectionOngoing) {
      return
    }

    // check if there are already boxes in the current sequence
    if (this.currentPickSelection.length > 0) {
      if (this.currentPickSelection.includes(this.selectedBox)) {
        return
      }
      // verify box has same rotation + alignment
      const selBox = this.boxes.find((b: BoxPosition) => b.id === this.selectedBox)
      const current = this.boxes.filter((b: BoxPosition) => this.currentPickSelection.includes(b.id!))
      if (!this.isSequenceInlineGroup([...current, selBox])) {
        return
      }
    }
    const pickSelection2 = [...this.currentPickSelection, this.selectedBox]
    this.$emit('pickSelection', pickSelection2)
  }

  @Watch('currentPickSelection')
  private currentPickSelectionWatcher() {
    if (this.boxSelectionOngoing) {
      const hasSelection = this.updateCurrentSelectionPreview()
      this.$emit('selecting', this.boxSelectionOngoing, [...this.currentPickSelection], this.copySequences, this.sequenceId)
      if (hasSelection) {
        this.handleGripperOverlay()
      } else {
        this.$emit('gripperOverlay', [])
      }
      return
    }
    if (this.preserveSequenceSelectionOnSequenceUpdate) {
      this.handleGripperOverlay()
      return
    }
    if (!this.boxSelectionOngoing && !this.preserveSequenceSelectionOnDone && this.selectSequenceByPickSelection()) {
      this.updateDisplayValues(this.currentSequence!)
      this.validateFields()
    }
    this.handleGripperOverlay()
  }

  @Watch('showGripperOverlay')
  private gripperOverlayWatcher() {
    this.handleGripperOverlay()
  }

  @Watch('palletRotation')
  private palletRotationWatcher() {
    this.handleGripperOverlay()
  }

  @Watch('sequenceBoxSelection')
  private sequenceBoxSelectionWatcher() {
    if (this.boxSelectionOngoing && this.boxSelectionOngoing !== this.sequenceBoxSelection) {
      this.boxSelectionOngoing = false
    }
  }

  get vacuumSectionItems (): number[] {
    return Array.from({length: this.getVacuumSectionCount()}, (_, index) => index + 1)
  }

  // =================
  // OTHER
  // =================
  private isValidOffsetX (v: any): boolean | string {
    return v === 0 || (v && v >= -this.gripperLength && v <= this.gripperLength) || 'some error text'
  }

  private isValidOffsetY (v: any): boolean | string {
    return v === 0 || (v && v >= -this.gripperWidth && v <= this.gripperWidth) || 'some error text'
  }

  private isValidApproachAngle (v: any): boolean | string {
    return v === 0 || (v && v >= -360 && v <= 360) || 'some error text'
  }

  private isValidApproachDistance (v: any): boolean | string {
    return v === 0 || (v && v >= 0) || 'some error text'
  }

  private validateFields () {
    this.maxSequenceId = (allBoxesInSequence(this.copySequences, this.boxes) || !this.isContinuousIds(this.getFilteredSequences().map(p => p.id!)))
        ? Math.max(...this.copySequences.map((s: Sequence) => s.id!))
        : Math.max(...this.getFilteredSequences().map((s: Sequence) => s.id!)) + 1
    // console.log('validateFields - maxSequenceId: ', this.maxSequenceId)
    this.maxPickId = (this.currentSequence && this.currentSequence.pick!.length === 1 && allBoxesInSequence(this.copySequences, this.boxes)) ? 1 : 2

    this.valid = this.isValidOffsetX (this.xGripperOffset) === true
        && this.isValidOffsetY (this.yGripperOffset) === true
        && this.isValidApproachAngle (this.approachAngle) === true
        && this.isValidApproachDistance (this.approachDistance) === true
        && (this.boxes && this.boxes.length > 0)
  }

  private nextSequenceOk () {
    return !allBoxesInSequence (this.copySequences, this.boxes)
  }

  private selectSequenceByPickSelection (): boolean {
    if (!this.currentPickSelection || this.currentPickSelection.length === 0) {
      return false
    }
    for (let i = 0; i < this.copySequences.length; i++) {
      for (let k = 0; k < this.copySequences[i].pick!.length; k++) {
        if (compare(this.copySequences[i].pick![k].boxesGroup, this.currentPickSelection)) {
          this.sequenceId = Number(this.copySequences[i].id!)
          this.pickId = k + 1
          this.currentSequence = this.copySequences[i]
          this.$emit('sequenceSelection', this.sequenceId)
          return true
        }
      }
    }
    return false
  }

  private sequenceIdChanged (val: number) {
    this.preserveSequenceSelectionOnDone = false
    this.sequenceId = Number(val)
    this.setCurrentSequence(this.sequenceId)
    this.updateDisplayValues (this.currentSequence!)
    const boxesGroup = this.currentSequence!.pick![this.pickId - 1].boxesGroup
    this.validateFields()
    this.$emit ('sequenceSelection', this.sequenceId)
    this.$emit ('pickSelection', boxesGroup)
    this.handleGripperOverlay()
  }

  private pickIdChanged (val: number) {
    this.pickId = Number(val)
    if (this.currentSequence) {
      const selPick = this.currentSequence.pick![this.pickId - 1]
      if (selPick == null) {
        // create new pick
        const newPick = {
          id: val,
          boxesGroup: [],
          zRot: 0
        }
        this.currentSequence.pick!.splice (newPick.id - 1, 0, newPick)
      }

      this.updateDisplayValues (this.currentSequence)
      const boxesGroup = this.currentSequence.pick![this.pickId - 1].boxesGroup
      this.$emit ('pickSelection', boxesGroup)
    }
  }

  private gripperOffsetChanged () {
    this.validateFields()
    if (this.isValidOffsetX (this.xGripperOffset) !== true
        || this.isValidOffsetY (this.yGripperOffset) !== true) {
      return
    }
    if (!this.currentSequence) {
      this.setCurrentSequence(this.sequenceId)
    }
    this.currentSequence!.gripperOffsetX = Math.floor (this.xGripperOffset)
    this.currentSequence!.gripperOffsetY = Math.floor (this.yGripperOffset)
    this.updatePlacePositions()
    this.updatePickPositions()
    this.preserveSequenceSelectionOnSequenceUpdate = true
    this.$emit ('sequences', this.copySequences)
    this.handleGripperOverlay()
  }

  private approachChanged () {
    this.validateFields()
    if (this.isValidApproachAngle (this.approachAngle) !== true
        || this.isValidApproachDistance (this.approachDistance) !== true) {
      return
    }
    if (!this.currentSequence) {
      this.setCurrentSequence(this.sequenceId)
    }
    this.currentSequence!.approachAngle = Math.floor(Number(this.approachAngle))
    this.currentSequence!.approachDistance = Math.floor(Number(this.approachDistance))
    this.preserveSequenceSelectionOnSequenceUpdate = true
    this.$emit ('sequences', this.copySequences)
  }

  private selectBoxes () {
    this.preserveSequenceSelectionOnDone = false
    this.boxSelectionOngoing = true

    // current sequence value
    const sequence = this.copySequences.find ((s: Sequence) => s.id === this.sequenceId)
    if (!sequence) {
      this.currentSequence = createSequence (this.sequenceId)
      this.copySequences.push (this.currentSequence)
    } else {
      this.currentSequence = sequence
    }
    this.applyCustomInfeedRotationToCurrentSequence()
    const boxesGroup = this.currentSequence.pick![this.pickId - 1].boxesGroup
    this.$emit ('selecting', this.boxSelectionOngoing, boxesGroup, this.copySequences, this.sequenceId)
  }

  private selectionDone () {
    this.boxSelectionOngoing = false
    this.preserveSequenceSelectionOnDone = true
    if (this.currentSequence) {
      const pickSelection = [...this.currentPickSelection]
      this.currentSequence.pick![this.pickId - 1].boxesGroup = pickSelection
      this.applyCustomInfeedRotationToCurrentSequence()
      this.applySelectedVacuumSectionsToCurrentPick()
      this.setPickPlaceZRotations()
      this.updatePlacePosition(this.currentSequence)
      this.updatePickPosition(this.currentSequence)
      this.$emit ('sequenceSelection', this.sequenceId)
      this.$emit ('selecting', this.boxSelectionOngoing, pickSelection, this.copySequences, this.sequenceId)
      this.handleGripperOverlay()
    }
  }

  private updateCurrentSelectionPreview (): boolean {
    if (!this.currentSequence || !this.currentSequence.pick || !this.currentSequence.pick[this.pickId - 1]) {
      return false
    }
    this.currentSequence.pick![this.pickId - 1].boxesGroup = [...this.currentPickSelection]
    this.applyCustomInfeedRotationToCurrentSequence()
    if (this.currentPickSelection.length === 0) {
      return false
    }
    this.applySelectedVacuumSectionsToCurrentPick()
    this.setPickPlaceZRotations()
    this.updatePlacePosition(this.currentSequence)
    this.updatePickPosition(this.currentSequence)
    return true
  }

  private updateDisplayValues (sequence: Sequence | undefined) {
    this.updateCustomInfeedRotationDisplay(sequence)
    this.xGripperOffset = (sequence && sequence.gripperOffsetX) ? sequence.gripperOffsetX : 0
    this.yGripperOffset = (sequence && sequence.gripperOffsetY) ? sequence.gripperOffsetY : 0
    this.approachAngle = (sequence && (sequence.approachAngle === 0 || sequence.approachAngle)) ? sequence.approachAngle : this.getDefaultApproachAngle()
    this.approachDistance = (sequence && (sequence.approachDistance === 0 || sequence.approachDistance)) ? sequence.approachDistance : this.getDefaultApproachDistance()
    this.updateSelectedVacuumSections()
    this.setPickPlaceZRotations()
  }

  private setPickPlaceZRotations() {
    if (this.currentSequence == null) {
      this.pickZRotations = this.rotations
      this.placeZRotations = this.rotations
      this.pickZRotation = 0
      this.placeZRotation = 0
      this.placeZRotationDisabled = true
      return
    }
    const firstPickBox =  this.boxes.find((b: BoxPosition) => this.currentSequence!.pick![0]!.boxesGroup!.includes(b.id!))!
    if (firstPickBox == null) {
      this.pickZRotation = this.currentSequence.pick![this.pickId - 1].zRot || 0
      this.placeZRotation = this.currentSequence.place![0].zRot || 0
      return
    }
    const firstPickBoxRotation = firstPickBox.rotation
    const firstPickBoxAlignedWithPallet = firstPickBoxRotation! % 180 === 0
    if (this.pickId === 1) {
      this.placeZRotationDisabled = false
      this.pickZRotations = this.rotations
      this.pickZRotation = this.currentSequence.pick![this.pickId - 1].zRot || Math.min(...this.pickZRotations)
      this.placeZRotations = (this.pickZRotation % 180 === 0) ?
          (firstPickBoxAlignedWithPallet ? [0, 180] : [90, 270]) :
          (firstPickBoxAlignedWithPallet ? [90, 270] : [0, 180])
      if (this.sequenceUsesCustomInfeedRotation(this.currentSequence)) {
        const customInfeedRotation = this.getSequenceCustomInfeedRotation(this.currentSequence)
        this.placeZRotations = this.placeZRotations
            .map(rotation => (rotation + customInfeedRotation) % 360)
      }
      if (this.currentSequence.place![0].zRot == null || !this.placeZRotations.includes(this.currentSequence.place![0].zRot)) {
        this.currentSequence.place![0].zRot = this.placeZRotations[0]
      }
      this.placeZRotation = this.currentSequence.place![0].zRot
    }
    if (this.pickId === 2) {
      this.placeZRotationDisabled = true
      const secondPickBox = this.boxes.find((b: BoxPosition) => this.currentSequence!.pick![1]!.boxesGroup!.includes(b.id!))!
      if (!secondPickBox) {
        this.pickZRotationDisabled = true
        this.pickZRotation = undefined
        return
      }
      const secondPickBoxRotation = secondPickBox.rotation
      this.pickZRotations = firstPickBoxRotation! % 180 === secondPickBoxRotation! % 180 ?
          [(this.currentSequence!.pick![0]!.zRot || 0), (((this.currentSequence!.pick![0]!.zRot || 0) + 180) % 360)] :
          (firstPickBoxAlignedWithPallet ? [90, 270] : [0, 180])
      this.pickZRotations.sort((a, b) => a - b)
      this.pickZRotationDisabled = false
      this.placeZRotations = [this.currentSequence.place![0].zRot!]
      this.pickZRotation = this.currentSequence.pick![this.pickId - 1].zRot == null || !this.pickZRotations.includes(this.currentSequence.pick![this.pickId - 1].zRot!)
          ? Math.min(...this.pickZRotations)
          : this.currentSequence.pick![this.pickId - 1].zRot
      this.placeZRotation = this.currentSequence.place![0].zRot!
    }
    this.currentSequence.pick![this.pickId - 1].zRot = this.pickZRotation
  }

  private currentPickHasBoxes () {
    return (this.currentSequence != null
            && this.currentSequence.pick != null
            && this.currentSequence.pick[this.pickId - 1].boxesGroup!.length > 0)
        || this.currentPickSelection.length > 0
  }

  private currentSequenceHasBoxes () {
    return this.currentSequence != null
        && this.currentSequence.pick != null
        && this.currentSequence.pick.some(p => p.boxesGroup != null && p.boxesGroup.length > 0)
  }

  private previousSequenceDisabled() {
    return !this.valid || this.sequenceId === 1 || this.boxSelectionOngoing
  }

  private nextSequenceDisabled () {
    return !this.valid || this.boxSelectionOngoing
        || (this.sequenceId === Math.max (...this.copySequences.map((s: Sequence) => s.id!))
            && (allBoxesInSequence (this.copySequences, this.boxes) || !this.isContinuousIds(this.getFilteredSequences().map(p => p.id!))))
  }

  private previousPickDisabled() {
    return !this.valid || this.pickId === 1 || this.boxSelectionOngoing
  }

  private nextPickDisabled () {
    const currentPickIsEmpty = (!this.currentSequence
        || !this.currentSequence.pick
        || !this.currentSequence.pick[this.pickId - 1]
        || this.currentSequence.pick[this.pickId - 1].boxesGroup!.length === 0)
    return !this.valid
        || currentPickIsEmpty
        || ((this.currentSequence && (!this.currentSequence.pick![this.pickId]
                || this.currentSequence.pick![this.pickId].boxesGroup!.length === 0))
            && allBoxesInSequence (this.copySequences, this.boxes))
  }

  private deleteSequence () {
    console.log ('deleteSequence: ', this.sequenceId, JSON.stringify (this.copySequences))
    const wasSelecting = this.boxSelectionOngoing
    this.boxSelectionOngoing = false
    this.preserveSequenceSelectionOnDone = false
    this.preserveSequenceSelectionOnSequenceUpdate = false
    const deleteSequence = this.sequenceId
    let nextSequence = this.copySequences.find (s => s.id === deleteSequence + 1)
    if (!nextSequence) {
      nextSequence = this.copySequences.find (s => s.id === deleteSequence - 1)
    }
    this.copySequences = this.copySequences.filter (s => s.id !== deleteSequence)
    this.sequenceId = (nextSequence) ? nextSequence.id! : 1
    this.pickId = 1
    this.currentSequence = nextSequence!
    this.updateDisplayValues (this.currentSequence)
    this.validateFields ()

    this.$emit ('sequences', this.copySequences)
    this.$emit ('pickSelection', [])
    if (wasSelecting) {
      this.$emit ('selecting', false, [], this.copySequences, this.sequenceId)
      this.$emit ('gripperOverlay', [])
    }
  }

  private removeSelection () {
    console.log ('removeSelection: ', this.pickId, this.currentPickSelection)
    if (this.pickId === 1) {
      this.deleteSequence()
    } else {
      this.currentSequence!.pick = this.currentSequence!.pick!.filter(p => p.id === 1)
      this.$emit ('sequences', this.copySequences)
      this.pickIdChanged(1)
    }
  }

  private pickZRotationChanged() {
    console.log ('pickZRotationChanged: ', this.pickZRotation)
    if (this.currentSequence) {
      this.currentSequence.pick![this.pickId - 1].zRot = this.pickZRotation
      this.setPickPlaceZRotations ()
      this.updatePlacePosition (this.currentSequence)
      this.updatePickPosition (this.currentSequence)
      this.preserveSequenceSelectionOnSequenceUpdate = true
      this.$emit ('sequences', this.copySequences)
      this.handleGripperOverlay()
    }
  }

  private placeZRotationChanged () {
    console.log ('placeZRotationChanged: ', this.placeZRotation)
    if (this.currentSequence) {
      this.currentSequence.place![0].zRot = this.placeZRotation
      this.updatePlacePosition (this.currentSequence)
      this.updatePickPosition (this.currentSequence)
      this.preserveSequenceSelectionOnSequenceUpdate = true
      this.$emit ('sequences', this.copySequences)
      this.handleGripperOverlay()
    }
  }

  private getSequencePlaceRotation (sequence: Sequence = this.currentSequence!): number {
    const place = sequence.place![0]
    const rotation = Number(place.zRot || 0)
    return ((rotation % 360) + 360) % 360
  }

  private getGripperOverlayRotation (): number {
    return this.getSequencePlaceRotation()
  }

  private getGripperOverlayCenter (): { x: number, y: number } {
    const place = this.currentSequence!.place![0]
    const rotation = this.getGripperOverlayRotation()
    const offsetX = Number(this.currentSequence!.gripperOffsetX || 0)
    const offsetY = Number(this.currentSequence!.gripperOffsetY || 0)
    const angle = rotation / 180 * Math.PI
    const rotatedOffset = {
      x: Math.round(Math.cos(angle) * offsetX - Math.sin(angle) * offsetY),
      y: Math.round(Math.sin(angle) * offsetX + Math.cos(angle) * offsetY)
    }
    return {
      x: place.x! + rotatedOffset.x,
      y: place.y! + rotatedOffset.y
    }
  }

  private getGripperBorderPoints () {
    let points: any = []
    if (this.showGripperOverlay && this.currentSequence) {
      const place = this.currentSequence.place![0]
      if (place.x == null || place.y == null) {
        return points
      }
      const rotation = this.getGripperOverlayRotation()
      const center = this.getGripperOverlayCenter()
      const border = getSequenceGripperBorder(rotation, center.x, center.y, this.gripperLength, this.gripperWidth, 0)
      points = getBorderPoints(border, false, false)
    }
    return points
  }

  private isContinuousIds(arr: number[]) {
    arr.sort((a, b) => a - b)
    if (arr.length < 2) {
      return true
    }
    for (let i = 1; i < arr.length; i++) {
      if (arr[i] !== arr[i - 1] + 1) {
        return false
      }
    }
    return true
  }

  private updatePlacePosition (sequence: Sequence) {
    const placePos = calculatePlacePosition(this.getSequencePlaceRotation(sequence), sequence.pick![0].boxesGroup!, this.boxes, this.boxDef, this.gripperLength, this.gripperWidth)
    sequence.place![0].x = placePos.x
    sequence.place![0].y = placePos.y
    // console.log('updatePlacePosition: ', placePos.x, placePos.y)
  }

  private updatePlacePositions() {
    for (const sequence of this.copySequences) {
      this.updatePlacePosition(sequence)
    }
  }

  private updatePickPosition (sequence: Sequence) {
    const conveyorBoxDef = this.getConveyorBoxDef(sequence)
    for (const pick of sequence.pick!) {
      const pickPos = (pick.id === 1) ? calculatePickPosition (pick.zRot!, pick.boxesGroup!, this.boxes, conveyorBoxDef, this.gripperLength, this.gripperWidth, this.programSettings)
          : calculatePickPosition2(sequence, this.boxes, this.boxDef, this.gripperLength, this.gripperWidth, this.programSettings, conveyorBoxDef)
      pick.x = pickPos.x
      pick.y = pickPos.y
    }
    // console.log('updatePickPosition - after: ', JSON.stringify(sequence))
  }

  private updatePickPositions () {
    for (const sequence of this.copySequences) {
      this.updatePickPosition (sequence)
    }
  }

  private handleGripperOverlay() {
    if (this.currentSequence) {
      const place = this.currentSequence.place![0]
      if (place.x == null || place.y == null) {
        this.$emit('gripperOverlay', [])
        return
      }
      const center = this.getGripperOverlayCenter()
      this.$emit('gripperOverlay', this.getGripperBorderPoints(),
          center.x,
          center.y,
          this.getGripperOverlayRotation())
    }
  }

  private setCurrentSequence(seqId: number) {
    const sequence = this.copySequences.find ((s: Sequence) => Number(s.id) === Number(seqId))
    if (!sequence) {
      // create new sequence
      this.currentSequence = createSequence (this.sequenceId)
      this.copySequences.push (this.currentSequence)
      this.pickId = 1
    } else {
      this.currentSequence = sequence
      if (this.currentSequence.pick!.length < this.pickId) {
        this.pickId = 1
      }
    }
  }

  private getVacuumSectionCount (): number {
    const count = Number(this.vacuumSections)
    if (!Number.isFinite(count)) {
      return 1
    }
    return Math.min(10, Math.max(1, Math.floor(count)))
  }

  private normalizeVacuumSections (sections: number[] | undefined): number[] {
    if (!this.vacuumSectionSelectionEnabled) {
      return []
    }
    const available = this.vacuumSectionItems
    const normalized = (sections || [])
        .map(section => Number(section))
        .filter(section => available.includes(section))
    const unique = Array.from(new Set(normalized)).sort((a, b) => a - b)
    return unique.length > 0 ? unique : [1]
  }

  private getCurrentPick () {
    if (!this.currentSequence || !this.currentSequence.pick || !this.currentSequence.pick[this.pickId - 1]) {
      return undefined
    }
    return this.currentSequence.pick[this.pickId - 1]
  }

  private updateSelectedVacuumSections () {
    if (!this.vacuumSectionSelectionEnabled) {
      this.selectedVacuumSections = []
      return
    }
    const pick = this.getCurrentPick()
    this.selectedVacuumSections = this.normalizeVacuumSections(pick ? pick.vacuumSections : undefined)
  }

  private applySelectedVacuumSectionsToCurrentPick () {
    const pick = this.getCurrentPick()
    if (pick) {
      pick.vacuumSections = this.normalizeVacuumSections(this.selectedVacuumSections)
    }
  }

  private getSequenceCustomInfeedRotation (sequence: Sequence | undefined = this.currentSequence): number {
    const rotation = getCustomInfeedRotation(sequence)
    return rotation || (sequence === this.currentSequence && this.customInfeedRotationEnabled ? Number(this.customInfeedRotation) || 0 : 0)
  }

  private sequenceUsesCustomInfeedRotation (sequence: Sequence | undefined = this.currentSequence): boolean {
    return hasCustomInfeedRotation(sequence) || (sequence === this.currentSequence && this.customInfeedRotationEnabled)
  }

  private isSequenceShortSideLeading (sequence: Sequence | undefined = this.currentSequence): boolean {
    const shortSideLeading = this.programSettings.boxOrientationOnConveyor === 'SHORT_SIDE_LEADING'
    return Math.abs(this.getSequenceCustomInfeedRotation(sequence)) % 180 !== 0 ? !shortSideLeading : shortSideLeading
  }

  private getConveyorBoxDef (sequence: Sequence): BoxDef {
    return getBoxDef(this.box, {
      ...this.programSettings,
      boxOrientationOnConveyor: this.isSequenceShortSideLeading(sequence) ? 'SHORT_SIDE_LEADING' : 'LONG_SIDE_LEADING'
    })
  }

  private applyCustomInfeedRotationToCurrentSequence () {
    if (!this.currentSequence) {
      return
    }
    if (this.currentSequenceHasBoxes() && !this.boxSelectionOngoing) {
      this.updateCustomInfeedRotationDisplay(this.currentSequence)
      return
    }
    if (this.customInfeedRotationEnabled) {
      this.currentSequence.customInfeedRotation = Number(this.customInfeedRotation)
    } else {
      delete this.currentSequence.customInfeedRotation
    }
  }

  private updateCustomInfeedRotationDisplay (sequence: Sequence | undefined) {
    const rotation = getCustomInfeedRotation(sequence)
    this.customInfeedRotationEnabled = hasCustomInfeedRotation(sequence)
    this.customInfeedRotation = this.customInfeedRotationEnabled ? rotation : 90
  }

  private canChangeCustomInfeedRotation () {
    return !this.boxSelectionOngoing && !this.currentSequenceHasBoxes()
  }

  private customInfeedRotationChanged () {
    if (!this.canChangeCustomInfeedRotation()) {
      this.updateCustomInfeedRotationDisplay(this.currentSequence)
      return
    }
    if (!this.customInfeedRotations.includes(Number(this.customInfeedRotation))) {
      this.customInfeedRotation = 90
    }
    if (!this.boxSelectionOngoing) {
      return
    }
    if (!this.currentSequence) {
      this.setCurrentSequence(this.sequenceId)
    }
    this.applyCustomInfeedRotationToCurrentSequence()
    this.preserveSequenceSelectionOnSequenceUpdate = true
    this.updateCurrentSelectionPreview()
    this.$emit('selecting', this.boxSelectionOngoing, [...this.currentPickSelection], this.copySequences, this.sequenceId)
    this.handleGripperOverlay()
  }

  private get customInfeedPreviewFrame () {
    const referenceOnRight = (this.programSettings.conveyorConfiguration || 'CENTER_RIGHT') === 'CENTER_RIGHT'
    const x = 8
    const y = 8
    const railWidth = 16
    const deckWidth = 160
    const height = 100
    const deckX = x + railWidth
    const flowX = deckX + deckWidth / 2
    return {
      viewBox: referenceOnRight ? '0 0 210 116' : '-60 0 270 116',
      x: x,
      y: y,
      deckX: deckX,
      deckWidth: deckWidth,
      railWidth: railWidth,
      width: deckWidth + railWidth * 2,
      height: height,
      referenceX: referenceOnRight ? deckX + deckWidth : deckX,
      originY: y + height,
      xAxis: 72,
      yAxis: 68,
      flowX: flowX,
      flowMarks: [0.42, 0.62].map(position => {
        const markY = y + height * position
        return `${flowX - 16},${markY - 9} ${flowX},${markY + 8} ${flowX + 16},${markY - 9}`
      }),
      boxInsetX: 4,
      boxInsetY: 4,
      referenceOnRight: referenceOnRight
    }
  }

  private get customInfeedPreviewBox () {
    const frame = this.customInfeedPreviewFrame
    const shortSideLeading = this.programSettings.boxOrientationOnConveyor === 'SHORT_SIDE_LEADING'
    const baseLength = Math.max(1, Number(shortSideLeading ? this.box.length : this.box.width) || 1)
    const baseWidth = Math.max(1, Number(shortSideLeading ? this.box.width : this.box.length) || 1)
    const sideRotated = Math.abs(Number(this.customInfeedRotation) || 0) % 180 !== 0
    const conveyorBoxLength = sideRotated ? baseWidth : baseLength
    const conveyorBoxWidth = sideRotated ? baseLength : baseWidth
    const scale = Math.min(104 / conveyorBoxWidth, 64 / conveyorBoxLength)
    const width = conveyorBoxWidth * scale
    const height = conveyorBoxLength * scale
    const x = frame.referenceOnRight ? frame.referenceX - width : frame.referenceX + frame.boxInsetY
    const y = frame.originY - frame.boxInsetX - height
    return {
      x: x,
      y: y,
      width: width,
      height: height,
      labels: this.getCustomInfeedPreviewLabels(height, width).map(label => ({
        id: label.id,
        x: x + label.y,
        y: y + height - label.x - label.width,
        width: label.height,
        height: label.width
      }))
    }
  }

  private getCustomInfeedPreviewLabels (width: number, height: number): CustomInfeedPreviewLabel[] {
    const conveyorLabelPosition = getCustomSolutionConveyorLabelPosition(
      this.programSettings.labelPosition || 'FRONT',
      Number(this.customInfeedRotation) || 0)
    if (conveyorLabelPosition === 'IGNORE') {
      return []
    }
    const labelLength = Math.min(width, height) / 2
    const labelThickness = Math.max(Math.min(width, height) * 0.08, 6)
    const borderWidth = 2
    const labels: CustomInfeedPreviewLabel[] = []
    const addLabel = (left: number, top: number, labelWidth: number, labelHeight: number) => {
      labels.push({
        id: labels.length,
        x: left - labelWidth / 2 + width / 2,
        y: top - labelHeight / 2 + height / 2,
        width: labelWidth,
        height: labelHeight
      })
    }
    switch (conveyorLabelPosition) {
      case 'FRONT_RIGHT_CORNER':
        addLabel(-width / 2 + labelThickness / 2 + borderWidth, -height / 2 + labelLength / 2 + borderWidth, labelThickness, labelLength)
        addLabel(-width / 2 + labelLength / 2 + borderWidth, -height / 2 + labelThickness / 2 + borderWidth, labelLength, labelThickness)
        break
      case 'RIGHT':
        addLabel(0, -height / 2 + labelThickness / 2, labelLength, labelThickness)
        break
      case 'RIGHT_BACK_CORNER':
        addLabel(width / 2 - labelLength / 2, -height / 2 + labelThickness / 2, labelLength, labelThickness)
        addLabel(width / 2 - labelThickness / 2, -height / 2 + labelLength / 2, labelThickness, labelLength)
        break
      case 'BACK':
        addLabel(width / 2 - labelThickness / 2, 0, labelThickness, labelLength)
        break
      case 'BACK_LEFT_CORNER':
        addLabel(width / 2 - labelLength / 2, height / 2 - labelThickness / 2, labelLength, labelThickness)
        addLabel(width / 2 - labelThickness / 2, height / 2 - labelLength / 2, labelThickness, labelLength)
        break
      case 'LEFT':
        addLabel(0, height / 2 - labelThickness / 2, labelLength, labelThickness)
        break
      case 'LEFT_FRONT_CORNER':
        addLabel(-width / 2 + labelThickness / 2, height / 2 - labelLength / 2, labelThickness, labelLength)
        addLabel(-width / 2 + labelLength / 2, height / 2 - labelThickness / 2, labelLength, labelThickness)
        break
      case 'FRONT':
      default:
        addLabel(-width / 2 + labelThickness / 2 + borderWidth, 0, labelThickness, labelLength)
        break
    }
    return labels
  }

  private isSequenceInlineGroup (boxes: BoxPosition[]): boolean {
    if (boxes.length < 2) {
      return boxes.length < 2
    }
    const customInfeedRotation = this.getSequenceCustomInfeedRotation()
    const boxesOnConveyor = customInfeedRotation
      ? boxes.map(box => ({...box, rotation: ((box.rotation || 0) + customInfeedRotation) % 360}))
      : boxes
    const boxesForAlignment = this.programSettings.robotType === 'CUSTOM_SOLUTION'
      ? boxesOnConveyor.map(box => ({...box, rotation: (box.rotation || 0) % 180}))
      : boxesOnConveyor
    const alignedBoxes = getAlignedGroupsInline(
      boxesForAlignment,
      this.box.length,
      this.box.width,
      customInfeedRotation
        ? this.isSequenceShortSideLeading()
        : 'SHORT_SIDE_LEADING' === this.programSettings.boxOrientationOnConveyor)
    return alignedBoxes.vertical.length === boxes.length
        || alignedBoxes.horizontal.length === boxes.length
  }

  private vacuumSectionsChanged () {
    this.selectedVacuumSections = this.normalizeVacuumSections(this.selectedVacuumSections)
    this.applySelectedVacuumSectionsToCurrentPick()
    if (!this.boxSelectionOngoing && this.getCurrentPick()) {
      this.preserveSequenceSelectionOnSequenceUpdate = true
      this.$emit('sequences', this.copySequences)
      this.handleGripperOverlay()
    }
  }

  private getDefaultApproachAngle (): number {
    const angle = this.programSettings && this.programSettings.approachAngle
    return angle === 0 || angle ? Math.floor(Number(angle)) : 45
  }

  private getDefaultApproachDistance (): number {
    const distance = this.programSettings && this.programSettings.approachDistance
    return distance === 0 || distance ? Math.floor(Number(distance)) : 200
  }

  private getFilteredSequences () {
    return this.copySequences.filter((s: Sequence) => s.pick![0].boxesGroup!.length > 0)
  }
}
